import { ActiveWorkingRoleSelector } from "./ActiveWorkingRoleSelector";
import {
  ArrowLeft,
  Bell,
  FileSpreadsheet,
  FileText,
  Menu,
  Search,
  ShieldCheck,
  Store,
} from "lucide-react";
import {
  can,
} from "../shared/auth/access";
import {
  previewRoleOptions,
  type PreviewRole,
} from "./navigation";
import type { useApplicationShell } from "./useApplicationShell";

export function AppHeader({ model }: { model: ReturnType<typeof useApplicationShell> ;}) {
  const { user, rolePreview, rolePreviewAvailable, globalSearchTerm, setGlobalSearchTerm, globalSearchResults, globalSearchOpen, setGlobalSearchOpen, globalSearchLoading, globalSearchError, globalSearchInputRef, globalSearchRootRef, setSidebarOpen, nestedBackAvailable, setRequestComposerOpen, roleSwitching, navigateTo, previousNav, goBack, activateRolePreview, switchActiveRole, openGlobalSearchResult } = model;
  return (<header className="topbar">
    {nestedBackAvailable || previousNav ? (
      <button
        className="back-button"
        type="button"
        aria-label={
          nestedBackAvailable
            ? "Satın alma taleplerine dön"
            : previousNav
              ? `Önceki ekrana dön: ${previousNav}`
              : "Önceki ekran bulunmuyor"
        }
        title={
          nestedBackAvailable
            ? "Satın alma taleplerine dön"
            : previousNav
              ? `${previousNav} ekranına dön`
              : undefined
        }
        onClick={goBack}
      >
        <ArrowLeft size={19} />
      </button>
    ) : null}
    <button
      className="menu-trigger"
      onClick={() => setSidebarOpen(true)}
      aria-label="Menüyü aç"
    >
      <Menu size={20} />
    </button>
    <div className="global-search" ref={globalSearchRootRef}>
      <Search size={17} />
      <input
        ref={globalSearchInputRef}
        aria-label="Genel arama"
        aria-autocomplete="list"
        aria-controls="global-search-results"
        aria-expanded={globalSearchOpen}
        role="combobox"
        placeholder="Talep, tedarikçi veya belge ara"
        value={globalSearchTerm}
        onFocus={() => setGlobalSearchOpen(true)}
        onChange={(event) => {
          setGlobalSearchTerm(event.target.value);
          setGlobalSearchOpen(true);
        }}
      />
      <kbd>⌘ K</kbd>
      {globalSearchOpen && globalSearchTerm.trim().length >= 2 ? (
        <div
          className="global-search-panel"
          id="global-search-results"
          role="listbox"
        >
          {globalSearchLoading ? (
            <div className="global-search-status">Aranıyor…</div>
          ) : globalSearchError ? (
            <div className="global-search-status is-error">
              {globalSearchError}
            </div>
          ) : globalSearchResults.length ? (
            globalSearchResults.map((result) => (
              <button
                key={`${result.type}-${result.id}`}
                className="global-search-result"
                role="option"
                aria-selected="false"
                onClick={() => openGlobalSearchResult(result)}
              >
                <span className="global-search-result-icon">
                  {result.type === "supplier" ? (
                    <Store size={17} />
                  ) : result.type === "document" ? (
                    <FileSpreadsheet size={17} />
                  ) : (
                    <FileText size={17} />
                  )}
                </span>
                <span>
                  <strong>{result.title}</strong>
                  <small>{result.subtitle}</small>
                </span>
                <em>
                  {result.type === "supplier"
                    ? "Tedarikçi"
                    : result.type === "document"
                      ? "Belge"
                      : "Talep"}
                </em>
              </button>
            ))
          ) : (
            <div className="global-search-status">
              Eşleşen kayıt bulunamadı.
            </div>
          )}
        </div>
      ) : null}
    </div>
    <div className="topbar-actions">
      <a className="icon-button" href="/vardiya-uretim-formu" aria-label="Vardiya üretim formları" title="Vardiya üretim formları">
        <FileText size={19} />
      </a>
      <ActiveWorkingRoleSelector user={user} rolePreview={Boolean(rolePreview)}
        switching={roleSwitching} onSwitch={switchActiveRole} />
      {rolePreviewAvailable && !rolePreview ? (
        <label className="role-preview-selector">
          <ShieldCheck size={15} />
          <span>Rol önizleme</span>
          <select
            aria-label="Önizlenecek rol"
            value=""
            onChange={(event) => {
              const role = event.target.value as PreviewRole;
              if (previewRoleOptions.some((option) => option.value === role)) {
                void activateRolePreview(role);
              }
            }}
          >
            <option value="">Rol seçin</option>
            {previewRoleOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {can(user, "admin.notifications.read") ? (
        <button
          className="icon-button"
          aria-label="E-posta bildirim kayıtları"
          onClick={() => navigateTo("E-posta Bildirimleri")}
        >
          <Bell size={19} />
        </button>
      ) : null}
      {can(user, "request.create") || can(user, "request.procurement.create") ? (
        <button
          className="primary-button"
          onClick={() => {
            navigateTo("Talepler");
            setRequestComposerOpen(true);
          }}
        >
          <span>Yeni talep</span>
        </button>
      ) : null}
    </div>
  </header>);
}
